import { combineReducers } from 'redux';

import {
  INVENTORY_ADJUSTMENT_SET_ADJUSTMENT_DETAIL,
  INVENTORY_ADJUSTMENT_SET_ADJUSTMENTS,
  INVENTORY_ADJUSTMENT_SET_OUTLETS,
  INVENTORY_ADJUSTMENT_SET_CURRENT_PAGE,
  INVENTORY_ADJUSTMENT_SET_TOTAL_PAGE,
  INVENTORY_ADJUSTMENT_OPEN_RIGHT_COLUMN,
  INVENTORY_ADJUSTMENT_CLOSE_RIGHT_COLUMN,
  INVENTORY_ADJUSTMENT_SHOW_ADD_ITEMS_MODAL,
  INVENTORY_ADJUSTMENT_HIDE_ADD_ITEMS_MODAL,
  INVENTORY_ADJUSTMENT_ADD_ITEMS_SET_ITEMS,
  INVENTORY_ADJUSTMENT_ADD_ITEMS_SET_INGREDIENTS,
  INVENTORY_ADJUSTMENT_ADD_ITEMS_SET_SELECTED_ID,
  INVENTORY_ADJUSTMENT_ADD_ITEMS_SHOW_LOADING,
  INVENTORY_ADJUSTMENT_ADD_ITEMS_HIDE_LOADING,
  INVENTORY_ADJUSTMENT_SHOW_CONFIRM_SUBMIT_MODAL,
  INVENTORY_ADJUSTMENT_HIDE_CONFIRM_SUBMIT_MODAL,
  INVENTORY_ADJUSTMENT_SET_INGREDIENT_ADJUSTMENTS,
  INVENTORY_ADJUSTMENT_SET_INGREDIENT_ADJUSTMENT_DETAIL,
  INVENTORY_ADJUSTMENT_ADD_ITEMS_HIDE_ALREADY_ADDED_ALERT,
  INVENTORY_ADJUSTMENT_ADD_ITEMS_SHOW_ALREADY_ADDED_ALERT,
  INVENTORY_ADJUSTMENT_SHOW_IMPORT_MODAL,
  INVENTORY_ADJUSTMENT_HIDE_IMPORT_MODAL,
  INVENTORY_ADJUSTMENT_ADD_ITEMS_SET_TOTAL_PAGE,
  INVENTORY_ADJUSTMENT_ADD_ITEMS_SET_CURRENT_PAGE,
  INVENTORY_ADJUSTMENT_ADD_ITEMS_SET_KEYWORD,
  INVENTORY_ADJUSTMENT_SET_SUMMARY_INVENTORY_ADJUSTMENT,
  INVENTORY_ADJUSTMENT_SET_SUMMARY_INGREDIENT_ADJUSTMENT,
  INVENTORY_ADJUSTMENT_ADD_ITEMS_SET_ITEM_HAS_RECIPE,
  INVENTORY_ADJUSTMENT_EXPORT_START,
  INVENTORY_ADJUSTMENT_EXPORT_FINISHED,
  INVENTORY_ADJUSTMENT_EXPORT_ERROR,
  INVENTORY_ADJUSTMENT_SET_ASYNCJOBID,
  INVENTORY_ADJUSTMENT_SET_ADDED_ITEM,
} from '../../actions/inventory/adjustment/constants';
import createReducer from '../../utils/createReducer';

const addItems = (() => {
  const items = createReducer([], {
    [INVENTORY_ADJUSTMENT_ADD_ITEMS_SET_ITEMS]: (draft, { payload }) =>
      // @ts-expect-error ts-migrate(2532) FIXME: Object is possibly 'undefined'.
      payload.items,
  });

  const ingredients = createReducer([], {
    [INVENTORY_ADJUSTMENT_ADD_ITEMS_SET_INGREDIENTS]: (draft, { payload }) =>
      // @ts-expect-error ts-migrate(2532) FIXME: Object is possibly 'undefined'.
      payload.ingredients,
  });

  const isLoading = createReducer(false, {
    [INVENTORY_ADJUSTMENT_ADD_ITEMS_SHOW_LOADING]: () => true,
    [INVENTORY_ADJUSTMENT_ADD_ITEMS_HIDE_LOADING]: () => false,
  });

  const selectedId = createReducer(null, {
    [INVENTORY_ADJUSTMENT_ADD_ITEMS_SET_SELECTED_ID]: (draft, { payload }) =>
      // @ts-expect-error ts-migrate(2532) FIXME: Object is possibly 'undefined'.
      payload.id,
  });

  const alreadyAddedAlert = createReducer(false, {
    [INVENTORY_ADJUSTMENT_ADD_ITEMS_SHOW_ALREADY_ADDED_ALERT]: () => true,
    [INVENTORY_ADJUSTMENT_ADD_ITEMS_HIDE_ALREADY_ADDED_ALERT]: () => false,
  });

  const currentPage = createReducer(null, {
    [INVENTORY_ADJUSTMENT_ADD_ITEMS_SET_CURRENT_PAGE]: (draft, { payload }) =>
      // @ts-expect-error ts-migrate(2532) FIXME: Object is possibly 'undefined'.
      payload.page,
  });

  const totalPage = createReducer(null, {
    [INVENTORY_ADJUSTMENT_ADD_ITEMS_SET_TOTAL_PAGE]: (draft, { payload }) =>
      // @ts-expect-error ts-migrate(2532) FIXME: Object is possibly 'undefined'.
      payload.page,
  });

  const keyword = createReducer(null, {
    [INVENTORY_ADJUSTMENT_ADD_ITEMS_SET_KEYWORD]: (draft, { payload }) =>
      // @ts-expect-error ts-migrate(2532) FIXME: Object is possibly 'undefined'.
      payload.keyword,
  });

  const itemHasRecipe = createReducer(false, {
    [INVENTORY_ADJUSTMENT_ADD_ITEMS_SET_ITEM_HAS_RECIPE]: (
      draft,
      { payload }
    ) =>
      // @ts-expect-error ts-migrate(2532) FIXME: Object is possibly 'undefined'.
      payload.itemHasRecipe,
  });

  const temporaryItem = createReducer(null, {
    // @ts-expect-error ts-migrate(2532) FIXME: Object is possibly 'undefined'.
    [INVENTORY_ADJUSTMENT_SET_ADDED_ITEM]: (draft, { payload }) => payload.item,
  });

  return combineReducers({
    items,
    ingredients,
    isLoading,
    selectedId,
    alreadyAddedAlert,
    currentPage,
    totalPage,
    keyword,
    itemHasRecipe,
    temporaryItem,
  });
})();

const adjustmentDetail = createReducer(null, {
  [INVENTORY_ADJUSTMENT_SET_ADJUSTMENT_DETAIL]: (draft, { payload }) =>
    // @ts-expect-error ts-migrate(2532) FIXME: Object is possibly 'undefined'.
    payload.adjustment,
});

const adjustmentExportState = createReducer(
  {
    exporting: false,
    asyncJobId: null,
    asyncJobCreated: false,
    pusherChannel: null,
    pusherEvent: null,
  },
  {}
);

const adjustments = createReducer([], {
  [INVENTORY_ADJUSTMENT_SET_ADJUSTMENTS]: (draft, { payload }) =>
    // @ts-expect-error ts-migrate(2532) FIXME: Object is possibly 'undefined'.
    payload.adjustments,
});

const currentPage = createReducer(null, {
  // @ts-expect-error ts-migrate(2532) FIXME: Object is possibly 'undefined'.
  [INVENTORY_ADJUSTMENT_SET_CURRENT_PAGE]: (draft, { payload }) => payload.page,
});

const idAsyncJob = createReducer(null, {
  [INVENTORY_ADJUSTMENT_SET_ASYNCJOBID]: (draft, { payload }) =>
    // @ts-expect-error ts-migrate(2532) FIXME: Object is possibly 'undefined'.
    payload.idAsyncJob,
});

const ingredientAdjustmentDetail = createReducer(null, {
  [INVENTORY_ADJUSTMENT_SET_INGREDIENT_ADJUSTMENT_DETAIL]: (
    draft,
    { payload }
  ) =>
    // @ts-expect-error ts-migrate(2532) FIXME: Object is possibly 'undefined'.
    payload.ingredientAdjustment,
});

const ingredientAdjustments = createReducer([], {
  [INVENTORY_ADJUSTMENT_SET_INGREDIENT_ADJUSTMENTS]: (draft, { payload }) =>
    // @ts-expect-error ts-migrate(2532) FIXME: Object is possibly 'undefined'.
    payload.ingredientAdjustments,
});

const isExportLoading = createReducer(false, {
  [INVENTORY_ADJUSTMENT_EXPORT_START]: () => true,
  [INVENTORY_ADJUSTMENT_EXPORT_FINISHED]: () => false,
  [INVENTORY_ADJUSTMENT_EXPORT_ERROR]: () => false,
});

const openRightColumn = createReducer(false, {
  [INVENTORY_ADJUSTMENT_OPEN_RIGHT_COLUMN]: () => true,
  [INVENTORY_ADJUSTMENT_CLOSE_RIGHT_COLUMN]: () => false,
});

const outlets = createReducer([], {
  // @ts-expect-error ts-migrate(2532) FIXME: Object is possibly 'undefined'.
  [INVENTORY_ADJUSTMENT_SET_OUTLETS]: (draft, { payload }) => payload.outlets,
});

const showAddItemsModal = createReducer(false, {
  [INVENTORY_ADJUSTMENT_SHOW_ADD_ITEMS_MODAL]: () => true,
  [INVENTORY_ADJUSTMENT_HIDE_ADD_ITEMS_MODAL]: () => false,
});

const showConfirmSubmitModal = createReducer(false, {
  [INVENTORY_ADJUSTMENT_SHOW_CONFIRM_SUBMIT_MODAL]: () => true,
  [INVENTORY_ADJUSTMENT_HIDE_CONFIRM_SUBMIT_MODAL]: () => false,
});

const showImportModal = createReducer(false, {
  [INVENTORY_ADJUSTMENT_SHOW_IMPORT_MODAL]: () => true,
  [INVENTORY_ADJUSTMENT_HIDE_IMPORT_MODAL]: () => false,
});

const summaryAdjustment = createReducer(
  {
    totalCount: 0,
    totalExpense: 0,
    totalIncome: 0,
    totalItems: 0,
  },
  {
    [INVENTORY_ADJUSTMENT_SET_SUMMARY_INVENTORY_ADJUSTMENT]: (
      draft,
      { payload }
    ) =>
      // @ts-expect-error ts-migrate(2532) FIXME: Object is possibly 'undefined'.
      payload.summaryAdjustment,
  }
);

const summaryIngredientAdjustment = createReducer(
  {
    totalCount: 0,
    totalExpense: 0,
    totalIncome: 0,
    totalIngredients: 0,
  },
  {
    [INVENTORY_ADJUSTMENT_SET_SUMMARY_INGREDIENT_ADJUSTMENT]: (
      draft,
      { payload }
    ) =>
      // @ts-expect-error ts-migrate(2532) FIXME: Object is possibly 'undefined'.
      payload.summaryIngredientAdjustment,
  }
);

const totalPage = createReducer(null, {
  // @ts-expect-error ts-migrate(2532) FIXME: Object is possibly 'undefined'.
  [INVENTORY_ADJUSTMENT_SET_TOTAL_PAGE]: (draft, { payload }) => payload.page,
});

export default combineReducers({
  addItems,
  adjustmentDetail,
  adjustmentExportState,
  adjustments,
  currentPage,
  idAsyncJob,
  ingredientAdjustmentDetail,
  ingredientAdjustments,
  isExportLoading,
  openRightColumn,
  outlets,
  showAddItemsModal,
  showConfirmSubmitModal,
  showImportModal,
  summaryAdjustment,
  summaryIngredientAdjustment,
  totalPage,
});
